import type { AdditionalFilterInDropdown, SelectedFiltersValues } from '../AdditionalFilters/constants';
import {
  isAdditionalBooleanFilter,
  isAdditionalBooleanFilterValue,
  isAdditionalFilterCalendar,
  isAdditionalFilterCompletionsRemaining,
  isAdditionalFilterDropdown,
  isAdditionalFilterLineItemEndDate,
  isAdditionalFilterRange,
  isCalendarDateFilterValue,
  isDropdownOptionValues,
  isLineItemEndDateFilterValue,
  isRangeFilterValue,
  isSimpleDropdownValues,
} from '../AdditionalFilters/utils';

export const getTransformedSelectedDropdownFilters = (
  selectedDropdownFilters: AdditionalFilterInDropdown[],
  selectedFiltersValues: SelectedFiltersValues
): AdditionalFilterInDropdown[] => {
  return selectedDropdownFilters.reduce((acc, filter) => {
    const selectedValues = selectedFiltersValues[filter.searchParam];

    if (selectedValues == null) return acc;

    if (
      (isAdditionalFilterRange(filter) && isRangeFilterValue(selectedValues)) ||
      (isAdditionalBooleanFilter(filter) && isAdditionalBooleanFilterValue(filter, selectedValues)) ||
      (isAdditionalFilterLineItemEndDate(filter) &&
        (isLineItemEndDateFilterValue(selectedValues) || isCalendarDateFilterValue(selectedValues))) ||
      (isAdditionalFilterCompletionsRemaining(filter) && isRangeFilterValue(selectedValues)) ||
      (isAdditionalFilterCalendar(filter) &&
        (isCalendarDateFilterValue(selectedValues) || isLineItemEndDateFilterValue(selectedValues)))
    ) {
      acc.push({ ...filter, selectedFilterValues: selectedValues } as AdditionalFilterInDropdown);
    } else if (
      isAdditionalFilterDropdown(filter) &&
      (isDropdownOptionValues(selectedValues) || isSimpleDropdownValues(selectedValues))
    ) {
      acc.push({
        ...filter,
        selectedFilterValues: selectedValues,
      });
    }

    return acc;
  }, new Array<AdditionalFilterInDropdown>());
};
